import './styles/desktop.css'
import './styles/mobile.css'
import { GetInfo } from './request'
import { Icon } from '@iconify/react/dist/iconify.js'


function BottomBar() {
    return (
        <div className='bottomBar'>
            <ContactInfo />
            <SendEmail />
        </div>
    )
}

function ContactInfo() {
    const info = GetInfo()
    return (
        <div>
            <h4>INFO DE CONTACTO</h4>
            <div className='contactInfo'>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <p>Tel. {info.tel}</p>
                    <p>Email. {info.email}</p>
                    <a className='linkText' href={info.site}>{info.site}</a>
                    <div style={{ display: 'flex', gap: "10px" }}>
                        <a href='/'><Icon className='socialImage' icon="uiw:facebook" /></a>
                        <a href='/'><Icon className='socialImage' icon="prime:twitter" /></a>
                    </div>
                </div>
                <p style={{ width: "180px" }}>{info.dir}</p>
            </div>
        </div>
    )
}


function SendEmail() {
    return (
        <div className='emailZone'>
            <h4>ESCRIBENOS</h4>
            <div className='contactForm compactForm'>
                <div className='nameEmail'>
                    <div className='formField'>
                        <label htmlFor='footer-name'>Escribe tu nombre</label>
                        <input id='footer-name' className='input' type='text' placeholder='Nombre' />
                    </div>
                    <div className='formField'>
                        <label htmlFor='footer-email'>Escribe tu email</label>
                        <input id='footer-email' className='input' type='email' placeholder='Email' />
                    </div>
                </div>
                <div className='nameEmail'>
                    <div className='formField'>
                        <label htmlFor='footer-msg' className='messageLabel'>Escribe tu mensaje</label>
                        <textarea id='footer-msg' className='input area' />
                    </div>
                    <button className='sendButton' type='button'>Enviar</button>
                </div>
            </div>
        </div>
    )
}

export default BottomBar
